import { EventEmitter } from 'events';
import assign from 'object-assign';
import { findIndex, reject } from 'lodash';
import i18next from 'i18next';
import ToastStore from 'stores/ToastStore';
import AdminAppDispatcher from '../dispatcher/AdminAppDispatcher';
import AdminConstants from '../constants/AdminConstants';
const ActionTypes = AdminConstants.ActionTypes;
let tariffRates = [];
let tariffRate = {};
function toast(message, level) {
    if (!level)
        level = 'error';
    ToastStore.getNotifications().push({
        title: message,
        body: '',
        level: level,
    });
    ToastStore.emitChange();
}
const TariffRatesStore = assign({}, EventEmitter.prototype, {
    defaults: {
        status: false,
        error: false,
        isAddOrRemove: false,
    },
    reset() {
        this.status = false;
        this.error = false;
        this.isAddOrRemove = false;
    },
    getStatus() {
        return this.status;
    },
    clearAll() {
        tariffRates = [];
        tariffRate = {};
        this.reset();
    },
    getError() {
        return this.error;
    },
    getIsAddOrRemove() {
        return this.isAddOrRemove;
    },
    setIsAddOrRemove() {
        this.isAddOrRemove = false;
    },
    getTariffRateIndex(tariffRate) {
        return findIndex(tariffRates, {
            _id: tariffRate._id,
        });
    },
    getTariffRates() {
        return tariffRates || [];
    },
    getTariffRate() {
        return tariffRate || {};
    },
    receiveTariffRates(data) {
        tariffRates = data;
        this.status = 'success';
    },
    receiveTariffRate(data) {
        tariffRate = data;
        this.status = 'success';
    },
    receiveAddTariffRateSuccess(data) {
        tariffRate = data.tariffRate;
        if (tariffRate)
            tariffRates.push(tariffRate);
        this.status = 'success';
        this.isAddOrRemove = true;
        toast(i18next.t('NEW_TARIFF_RATE_ADDED'), 'success');
    },
    receiveUpdateTariffRateSuccess(data) {
        tariffRate = data;
        if (tariffRate) {
            const idx = this.getTariffRateIndex(tariffRate);
            if (idx < tariffRates.length) {
                tariffRates[idx] = tariffRate;
            }
        }
        this.status = 'success';
        toast(i18next.t('TARIFF_RATE_UPDATED'), 'success');
    },
    receiveUpdateTariffRateFail(data) {
        this.status = 'fail';
        this.error = data.entity;
        toast(i18next.t('TARIFF_RATE_UPDATE_FAILED'), 'error');
    },
    receiveRemoveTariffRateSuccess(data) {
        toast(i18next.t('TARIFF_RATE_REMOVED'), 'success');
        tariffRate = data;
        if (tariffRate) {
            tariffRates = reject(tariffRates, function (item) {
                return item._id === tariffRate._id;
            });
        }
        this.status = 'success';
        this.isAddOrRemove = true;
    },
    receiveRemoveTariffRateFail(data) {
        this.status = 'fail';
        this.isAddOrRemove = false;
        this.error = data.entity;
        toast(i18next.t('TARIFF_RATE_REMOVE_FAILED'), 'error');
    },
    emitChange() {
        this.emit('change');
    },
    addChangeListener(callback) {
        this.on('change', callback);
    },
    removeChangeListener(callback) {
        this.removeListener('change', callback);
    },
});
TariffRatesStore.dispatchToken = AdminAppDispatcher.register(function (payload) {
    const action = payload.action;
    switch (action.type) {
        case ActionTypes.RECEIVE_TARIFFRATES:
            TariffRatesStore.receiveTariffRates(action.data);
            TariffRatesStore.emitChange();
            break;
        case ActionTypes.RECEIVE_TARIFFRATE:
            TariffRatesStore.receiveTariffRate(action.data);
            TariffRatesStore.emitChange();
            break;
        case ActionTypes.UPDATE_TARIFFRATE_SUCCESS:
            TariffRatesStore.receiveUpdateTariffRateSuccess(action.data);
            TariffRatesStore.emitChange();
            break;
        case ActionTypes.UPDATE_TARIFFRATE_FAIL:
            TariffRatesStore.receiveUpdateTariffRateFail(action.data);
            TariffRatesStore.emitChange();
            break;
        case ActionTypes.REMOVE_TARIFFRATE_SUCCESS:
            TariffRatesStore.receiveRemoveTariffRateSuccess(action.data);
            TariffRatesStore.emitChange();
            break;
        case ActionTypes.REMOVE_TARIFFRATE_FAIL:
            TariffRatesStore.receiveRemoveTariffRateFail(action.data);
            TariffRatesStore.emitChange();
            break;
        case ActionTypes.ADD_TARIFFRATE_SUCCESS:
            TariffRatesStore.receiveAddTariffRateSuccess(action.data);
            TariffRatesStore.emitChange();
            break;
        default:
            break;
    }
});
export default TariffRatesStore;
